import { useState } from 'react';

export default function SubscribeCTA() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotVal = (formData.get('website_alt') as string || '').trim();

    if (honeypotVal) {
      setStatus('success');
      setEmail('');
      return;
    }

    const emailVal = (formData.get('email') as string || '').trim();
    if (!emailVal) {
      setErrorMsg('请输入邮箱地址');
      return;
    }

    setStatus('loading');
    setErrorMsg('');

    try {
      const res = await fetch('http://gjxfl.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: emailVal }).toString(),
      });
      const text = await res.text();
      let parsed = null;
      try { parsed = JSON.parse(text); } catch { /* ignore */ }
      const serverMsg = parsed?.meta?.message || parsed?.message || text || '';

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const msg = serverMsg && serverMsg.includes('spam') ? '提交失败，请稍后重试' : (serverMsg || '提交失败，请稍后重试');
        setErrorMsg(msg);
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络错误，请稍后重试');
      setStatus('error');
    }
  };

  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20geometric%20pattern%20with%20red%20and%20purple%20undertones%2C%20mysterious%20void%20with%20subtle%20grid%20lines%2C%20cyberpunk%20noir%20background%2C%20dark%20ambient%20texture%2C%20no%20text%2C%20no%20people%2C%20minimalist%20yet%20atmospheric&width=1800&height=800&seq=cta-bg-subscribe&orientation=landscape"
          alt="订阅背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-background-50/80"></div>
      </div>

      <div className="relative z-10 max-w-[700px] mx-auto px-6 text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-50 mb-4 tracking-wider">
          订阅<strong className="text-primary-400">暗网爆料</strong>
        </h2>
        <p className="text-foreground-400 text-base leading-relaxed mb-10">
          第一时间获取最新黑料推送<br className="hidden sm:block" />
          网红塌房、明星泄露、博主反差 —— 不错过任何一个瓜
        </p>

        <form onSubmit={handleSubmit}>
          <div className="relative max-w-md mx-auto">
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => { setEmail(e.target.value); if (status !== 'idle') setStatus('idle'); }}
                placeholder="输入你的邮箱地址"
                required
                className="flex-1 px-5 py-3.5 bg-background-200 border border-background-300/60 rounded-full sm:rounded-r-none text-foreground-100 text-sm placeholder:text-foreground-600 outline-none focus:border-primary-500/50 transition-colors"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="mt-3 sm:mt-0 px-8 py-3.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full sm:rounded-l-none hover:bg-primary-600 transition-all duration-200 flex items-center justify-center space-x-2 whitespace-nowrap cursor-pointer disabled:opacity-60"
              >
                <i className="ri-fire-line w-4 h-4 flex items-center justify-center"></i>
                <span>{status === 'loading' ? '订阅中...' : '立即订阅'}</span>
                <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
              </button>
            </div>

            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />
          </div>
        </form>

        {status === 'success' && (
          <p className="mt-4 text-accent-400 text-sm">订阅成功！最新爆料将第一时间送达你的邮箱。</p>
        )}
        {status === 'error' && errorMsg && (
          <p className="mt-4 text-red-400 text-sm">{errorMsg}</p>
        )}

        <p className="mt-6 text-foreground-600 text-xs">订阅即表示同意接收爆料推送邮件，我们承诺不发送垃圾邮件</p>
      </div>
    </section>
  );
}